<template>
  <div>
    <div class="card card-custom gutter-b example example-compact">
      <div class="card-header">
        <div class="card-title">
          <h3>FAQ</h3>
        </div>
        <div class="card-toolbar">
          <v-btn
            class="px-7 py-3 font-size-3 text-white invite-btn"
            @click="goToAddNew"
          >
            <b-icon
              icon="plus-circle-fill"
              scale="1"
              aria-hidden="true"
              variant="light"
              class="mr-2"
            ></b-icon>
            Add New
          </v-btn>
        </div>
      </div>
      <div class="card-body">
        <!--        <div-->
        <!--            class="input-group spinner-input spinner-sm spinner-brand spinner-right search-bar"-->
        <!--        >-->
        <!--          <div class="input-group-prepend">-->
        <!--            <span class="input-group-text">-->
        <!--              <i class="flaticon2-search-1"></i>-->
        <!--            </span>-->
        <!--          </div>-->
        <!--          <b-form-input-->
        <!--              type="text"-->
        <!--              placeholder="Search faq name..."-->
        <!--              v-model.lazy="searchQuestionKey"-->
        <!--              class="form-control quick-search-input col-md-4"-->
        <!--          ></b-form-input>-->
        <!--        </div>-->
        <div class="table-responsive mt-5">
          <v-simple-table class="record-table">
            <thead>
              <tr>
                <th width="10%" class="text-center align-middle">Sr.No.</th>
                <th
                  width="35%"
                  class="text-center align-middle"
                  @click="
                    sortListing(
                      'question',
                      filter.orderBy === 'asc' ? 'desc' : 'asc'
                    )
                  "
                >
                  Question
                  <span class="tbl-sort-icons ml-2">
                    <i
                      class="fa fa-sort"
                      aria-hidden="true"
                      v-if="filter.orderCol !== 'question'"
                    ></i>
                    <i
                      class="fa fa-sort-up"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'question' &&
                        filter.orderBy === 'asc'
                      "
                    ></i>
                    <i
                      class="fa fa-sort-down"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'question' &&
                        filter.orderBy === 'desc'
                      "
                    ></i>
                  </span>
                </th>
                <th width="35%" class="text-center align-middle">Answer</th>
                <th class="text-center align-middle" width="20%">Actions</th>
              </tr>
            </thead>
            <tr>
              <td></td>
              <td>
                <div class="search-input-div">
                  <v-text-field
                    dense
                    autocomplete="new-password"
                    v-model.lazy="searchQuestionKey"
                    solo
                    label="Search question..."
                    clearable
                  ></v-text-field>
                </div>
              </td>
              <td>
                <div class="search-input-div">
                  <v-text-field
                    dense
                    autocomplete="new-password"
                    v-model.lazy="searchAnswerKey"
                    solo
                    label="Search answer..."
                    clearable
                  ></v-text-field>
                </div>
              </td>
              <td></td>
            </tr>
            <tbody v-if="faqs.length">
              <tr v-for="(faq, i) in faqs" :key="faq.id">
                <td class="align-middle clickable-td" @click="goToEdit(faq.id)">
                  {{ i + 1 }}
                </td>
                <td class="align-middle clickable-td" @click="goToEdit(faq.id)">
                  {{ faq.question }}
                </td>
                <td
                  class="align-middle"
                  v-html="
                    faq.answer.length > 100
                      ? faq.answer.substring(0, 100) + '...'
                      : faq.answer
                  "
                ></td>
                <td class="align-middle text-center icon-wrapper-block">
                  <router-link :to="'/admin/edit-faq/' + faq.id">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <i v-bind="attrs" v-on="on" class="flaticon-edit-1"></i>
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                  </router-link>
                  <a
                    v-if="faq.is_status == 1"
                    @click="changeStatus(faq.id, faq.is_status)"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="eye"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Enabled</span>
                    </v-tooltip>
                  </a>
                  <a v-else @click="changeStatus(faq.id, faq.is_status)">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="eye-slash"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Disabled</span>
                    </v-tooltip>
                  </a>
                  <a @click="deletefaq(faq.id)">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="trash"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Delete</span>
                    </v-tooltip>
                  </a>
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="loading_faqs" class="loading-tbody">
              <td colspan="5">
                Loading...
                <b-spinner variant="primary" label="Text Centered"></b-spinner>
              </td>
            </tbody>
            <tbody v-else class="loading-tbody">
              <tr>
                <td colspan="5">No Records Found</td>
              </tr>
            </tbody>
          </v-simple-table>
          <div class="d-flex pagination-block">
            <b-pagination
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total-rows="pagination.paginationRows"
              prev-text="Prev"
              next-text="Next"
              first-number
              last-number
              @change="paginationChange"
            >
              <template #prev-text
                ><span
                  ><b-icon
                    icon="chevron-left"
                    aria-hidden="true"
                  ></b-icon></span
              ></template>
              <template #next-text
                ><span
                  ><b-icon
                    icon="chevron-right"
                    aria-hidden="true"
                  ></b-icon></span
              ></template>
            </b-pagination>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="showFileModal"
      class="file-modal"
      centered
      hide-footer
      resizable
    >
      <div v-if="modalFile">
        <div>
          <b-img :src="modalFile" class="modal-image"></b-img>
        </div>
      </div>
    </b-modal>
    <v-dialog v-model="statusDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Please Confirm
        </v-card-title>

        <v-card-text>
          <span>Wollen Sie den Status wirklich ändern?</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            :disabled="disabledCancel"
            class="no-button"
            @click="hideModal"
          >
            No
          </v-btn>
          <v-btn
            type="submit"
            @click="changeStatusRecord(statusRecordId, newStatus)"
            ref="kt_form_submit_btn"
            class="yes-button"
            :loading="yesActionLoading"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Please Confirm
        </v-card-title>

        <v-card-text>
          <span>Wollen Sie den Eintrag wirklich löschen?</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            :disabled="disabledCancel"
            class="no-button"
            @click="hideModal"
          >
            No
          </v-btn>
          <v-btn
            type="submit"
            @click="deleteRecord(deleteRecordId)"
            ref="kt_form_submit_btn"
            class="yes-button"
            :loading="yesActionLoading"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <notifications group="faqs" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import HtmlClass from "@/core/services/htmlclass.service";
import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Notifications from "vue-notification";
import Loader from "@/components/admin/layout/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import adminAPI from "@/api/admin";

Vue.use(Notifications);

export default {
  name: "Faq",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      // show page loading
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.userId = localStorage.getItem("local_products_user_access_id");
      this.getFaqs();
    }
  },
  data() {
    return {
      loading_faqs: true,
      filter: {
        orderCol: "id",
        orderBy: "desc",
      },
      searchQuestionKey: "",
      searchAnswerKey: "",
      userId: null,
      showFileModal: false,
      modalFile: null,
      statusDialog: false,
      deleteDialog: false,
      deleteRecordId: null,
      statusRecordId: null,
      yesActionLoading: false,
      disabledCancel: false,
      newStatus: null,
      faqs: [],
      pagination: {
        currentPage: 1,
        perPage: 20,
        paginationRows: "",
      },
    };
  },
  components: {},
  watch: {
    searchQuestionKey: {
      handler: function (val, oldVal) {
        this.faqs = [];
        this.loading_faqs = true;
        this.getFaqs();
      },
      deep: true,
    },
    searchAnswerKey: {
      handler: function (val, oldVal) {
        this.faqs = [];
        this.loading_faqs = true;
        this.getFaqs();
      },
      deep: true,
    },
  },
  methods: {
    goToEdit(id) {
      this.$router.push({ path: "/admin/edit-faq/" + id });
    },
    hideModal() {
      this.statusDialog = false;
      this.yesActionLoading = false;
      this.deleteDialog = false;
    },
    goToAddNew() {
      this.$router.push({ name: "add-faq" });
    },
    clearInput(type) {
      switch (type) {
        case "name":
          this.searchQuestionKey = "";
          break;
      }
    },
    sortListing(orderCol, orderBy) {
      if (!this.loading_faqs) {
        this.faqs = [];
        this.filter.orderCol = orderCol;
        this.filter.orderBy = orderBy;
        this.pagination.currentPage = 1;
        this.loading_faqs = true;
        this.getFaqs();
      }
    },
    openFileModal(file) {
      this.showFileModal = true;
      this.modalFile = file;
    },
    paginationChange() {
      this.faqs = [];
      this.loading_faqs = true;
      setTimeout(() => {
        this.getFaqs();
      }, 100);
    },
    getFaqs() {
      let data = {
        user_id: this.currentUser.id,
        page: this.pagination.currentPage,
        search_question_field: this.searchQuestionKey,
        search_answer_field: this.searchAnswerKey,
        per_page: this.pagination.perPage,
        sort_column: this.filter.orderCol,
        sort_type: this.filter.orderBy,
      };
      adminAPI
        .getFaqs(data)
        .then((response) => {
          if (response.status == "success") {
            this.faqs = response.data;
            this.pagination.paginationRows = response.count;
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.loading_faqs = false;
          } else {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.loading_faqs = false;
            this.$notify({
              group: "faqs",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.loading_faqs = false;
          this.$notify({
            group: "faqs",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    deletefaq(id) {
      this.deleteDialog = true;
      this.deleteRecordId = id;
    },
    deleteRecord(id) {
      this.disabledCancel = true;
      this.yesActionLoading = true;

      adminAPI
        .deleteFaq({ id: id })
        .then((response) => {
          if (response.status == "success") {
            this.deleteDialog = false;
            this.deleteRecordId = null;
            this.disabledCancel = false;
            this.yesActionLoading = false;
            this.$notify({
              group: "faqs",
              type: "success",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
            this.pagination.currentPage = 1;
            this.getFaqs();
          } else {
            this.deleteDialog = false;
            this.deleteRecordId = null;
            this.disabledCancel = false;
            this.yesActionLoading = false;
            this.$notify({
              group: "faqs",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.deleteDialog = false;
          this.deleteRecordId = null;
          this.disabledCancel = false;
          this.yesActionLoading = false;
          this.$notify({
            group: "faqs",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    changeStatus(id, status) {
      if (status == 0) {
        this.newStatus = "1";
      } else {
        this.newStatus = "0";
      }
      this.statusDialog = true;
      this.statusRecordId = id;
    },
    changeStatusRecord(id, status) {
      this.yesActionLoading = true;
      this.disabledCancel = true;
      adminAPI
        .statusFaq({ id: id, status: status })
        .then((response) => {
          if (response.status == "success") {
            this.statusDialog = false;
            this.statusRecordId = null;
            this.newStatus = null;
            this.yesActionLoading = false;
            this.disabledCancel = false;
            this.$notify({
              group: "faqs",
              type: "success",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
            this.getFaqs();
          } else {
            this.statusDialog = false;
            this.statusRecordId = null;
            this.newStatus = null;
            this.yesActionLoading = false;
            this.disabledCancel = false;
            this.$notify({
              group: "faqs",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.statusDialog = false;
          this.statusRecordId = null;
          this.newStatus = null;
          this.yesActionLoading = false;
          this.disabledCancel = false;
          this.$notify({
            group: "faqs",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.invite-btn {
  background-color: #3d5a80 !important;
}

.invite-btn:hover {
  background-color: #002c47 !important;
}

table {
  text-align: center;
  font-size: 15px;
}

.new-btn-text {
  margin-left: 10px;
  font-size: 13px;
}

a {
  cursor: pointer;
}

.file-modal {
  padding: 0;
  margin: 0;
}

.modal-image {
  width: 100%;
}

.submit-btn-fill-color {
  background-color: #ff5252 !important;
}

.submit-btn-fill-color:hover {
  background-color: red !important;
}

.table-image {
  cursor: pointer;
}

th {
  cursor: pointer;
}

.search-input-div {
  position: relative;
}

.loading-tbody {
  text-align: center;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  height: 48px;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 14px;
  height: 48px;
}

.clickable-td {
  cursor: pointer;
}
</style>